/* eslint-disable @typescript-eslint/no-explicit-any */
import pdfMake from "pdfmake/build/pdfmake";
import "pdfmake/build/vfs_fonts";

interface ProdutoEstoque {
  ean: string;
  descricao: string;
  localizado: string;
  preco: number;
  un: string;
  referencia: string | null;
  pvenda: number;
  marca: string;
  idgrupo: string;
  quan: number;
  totalcompra: number;
  total: number;
}

async function RelatorioEstoquepdf(dados: ProdutoEstoque[], periodo: string) {

  const totalCompra = dados.reduce(
    (acc, item) => acc + (item?.totalcompra ?? 0),
    0
  );
  const totalQtd = dados.reduce(
    (acc, item) => acc + (item?.quan ?? 0),
    0
  );

  const totalVenda = dados.reduce(
    (acc, item) => acc + (item?.total ?? 0),
    0
  );

  const linhas: any[] = [];

  dados.forEach((r) => {

    linhas.push([
      { text: r.ean ?? "", fontSize: 8 },

      {
        text: r.descricao + (r.referencia ? `\nREF: ${r.referencia}` : ""),
        fontSize: 8
      },

      { text: r.localizado ?? "", fontSize: 8 },

      {
        text: r.un ?? "",
        alignment: "right",
        fontSize: 8
      },

      {
        text: formatMoney(r.quan) ?? 0,
        alignment: "right",
        fontSize: 8
      },

      {
        text: formatMoney(r.preco),
        alignment: "right",
        fontSize: 8
      },

      {
        text: formatMoney(r.pvenda),
        alignment: "right",
        fontSize: 8
      },

      {
        text: formatMoney(r.totalcompra),
        alignment: "right",
        fontSize: 8
      },

      {
        text: formatMoney(r.total),
        alignment: "right",
        bold: true,
        fontSize: 8
      }

    ]);

  });

  const documentDefinition: any = {

    pageSize: "A4",
    pageMargins: [25, 25, 25, 25],

    content: [

      {
        text: process.env.REACT_APP_URL_EMPRESA,
        fontSize: 14,
        bold: true,
        alignment: "center",
        margin: [0, 0, 0, 4]
      },

      {
        text: "RELATÓRIO DE ESTOQUE",
        fontSize: 12,
        bold: true,
        alignment: "center"
      },

      {
        text: periodo,
        alignment: "center",
        fontSize: 9,
        margin: [0, 0, 0, 10]
      },

      {
        table: {

          headerRows: 1,

          widths: [40, "*", 40, 35, 45, 45, 45, 55, 55],

          body: [

            [
              { text: "EAN", bold: true, fillColor: "#e5e7eb", fontSize: 8 },

              { text: "Produto", bold: true, fillColor: "#e5e7eb", fontSize: 8 },

              { text: "Local", bold: true, fillColor: "#e5e7eb", fontSize: 8 },

              { text: "UN", bold: true, alignment: "right", fillColor: "#e5e7eb", fontSize: 8 },

              { text: "Qtd", bold: true, alignment: "right", fillColor: "#e5e7eb", fontSize: 8 },

              { text: "Custo UN", bold: true, alignment: "right", fillColor: "#e5e7eb", fontSize: 8 },

              { text: "Venda UN", bold: true, alignment: "right", fillColor: "#e5e7eb", fontSize: 8 },

              { text: "Valor em Custo", bold: true, alignment: "right", fillColor: "#e5e7eb", fontSize: 8 },

              { text: "Valor em Venda", bold: true, alignment: "right", fillColor: "#e5e7eb", fontSize: 8 }
            ],

            ...linhas

          ]
        },

        layout: {

          fillColor: function (rowIndex: number) {

            if (rowIndex === 0) return null;

            return rowIndex % 2 === 0 ? "#f9fafb" : null;

          },

          hLineColor: () => "#d1d5db",
          vLineWidth: () => 0

        }

      },

      {
        margin: [0, 0, 0, 0],

        table: {

          widths: [40, "*", 40, 35, 35, 45, 45, 60, 60],

          body: [

            [
              { text: "", colSpan: 7, border: [false, false, false, false] }, {}, {}, {}, {}, {}, {},

              {
                text: "Total Qtd",
                alignment: "right",
                fontSize: 9
              },

              {
                text: formatMoney(totalQtd),
                alignment: "right",
                bold: true,
                fontSize: 9
              }
            ],
            [
              { text: "", colSpan: 7, border: [false, false, false, false] }, {}, {}, {}, {}, {}, {},

              {
                text: "Total Preço Compra",
                alignment: "right",
                fontSize: 9
              },

              {
                text: formatMoney(totalCompra),
                alignment: "right",
                bold: true,
                fontSize: 9
              }

            ],

            [
              { text: "", colSpan: 7, border: [false, false, false, false] }, {}, {}, {}, {}, {}, {},

              {
                text: "Total Preço Venda",
                alignment: "right",
                fontSize: 9
              },

              {
                text: formatMoney(totalVenda),
                alignment: "right",
                bold: true,
                fontSize: 9
              }

            ]

          ]

        },

        layout: {

          hLineColor: () => "#d1d5db",
          vLineColor: () => "#d1d5db",
          vLineWidth: () => 0

        }

      }
    ]
  };
  pdfMake.createPdf(documentDefinition).open();

}
function formatMoney(value: number) {
  const v = Number(value ?? 0);
  return new Intl.NumberFormat("pt-BR", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(Number(v.toFixed(2)));

}

export default RelatorioEstoquepdf;